<template>
  <div>
    <b-modal id="success" hide-header hide-footer body-text-variant="dark">
      <template class="bg-success" #modal-title>
        Info
      </template>
      <div class="d-block text-center p-4">
        <h3>Successfully saved.</h3>
      </div>
      <b-button variant="primary" class="mt-3 px-4 float-right" @click="$bvModal.hide('success')">OK</b-button>
    </b-modal>
    <div class="position-fixed col-xl-5 col-lg-7 col-md-9 col-sm-12" style="right: 0; top: 0; z-index: 1040;">
      <div v-if="holdOn" class="hold-on"></div>
      <b-card class="rounded korpa" v-if="Object.keys(order).length">
        <ul class="list-group mb-3">
          <li class="list-group-item" v-for="(val, key) of order" v-bind:key="val.sku">
            <div class="row">
              <div class="col-6">
                <b-icon @click="reduceCount(key)" class="mr-2 remove-icon" icon="trash" variant="danger"></b-icon> <strong>{{key}}</strong>
              </div>
              <div class="col-3 text-center">
                <input class="col-12 border-0" v-model.number="val.price" type="number" step="0.01" inputmode="decimal">
              </div>
              <div class="col-3 text-left">
                x{{val.count}} = <strong class="float-right">{{ val.count*val.price }}kr</strong>
              </div>
            </div>
          </li>
        </ul>
        <b-button @click="otkazi" variant="danger" class="m-1">
          <b-icon class="mr-2 remove-icon" icon="trash" variant="light"></b-icon>
        </b-button>
        <b-button @click="storeOrder" variant="success" class="float-right">
          <strong> {{totalCart.toLocaleString()}}kr </strong>
          <b-icon-bag></b-icon-bag>
        </b-button>
        <b-button @click="exportArticles" variant="primary" class="float-right mr-2">EXPORT
          <b-icon-file-plus></b-icon-file-plus>
        </b-button>
      </b-card>
    </div>
    <div class="d-print-none page-head">
      <div>
        <h3>Lager List</h3>
        <p v-if="total" class="page-head-sub">Total value: <strong>{{total}} kr</strong></p>
      </div>
    </div>
    <div class="d-print-none toolbar pretraga-container">
      <div class="toolbar-field">
        <b-form-input
          class="pretraga"
          v-model="search"
          type="text"
          placeholder="Enter SKU to search for">
        </b-form-input>
      </div>
      <b-button @click="printaj" variant="secondary" class="d-none d-md-inline-block"><b-icon-printer class="mr-1"></b-icon-printer>Print</b-button>
    </div>
    <div class="lista">
      <div v-if="lokacija" class="fixed-top p-4 alert alert-primary text-center">
        ARTICLE LOCATION: {{lokacija}}
      </div>
      <div class="text-center" v-if="loading">
        <b-icon icon="arrow-clockwise" animation="spin" font-scale="3"></b-icon>
      </div>
      <table v-else class="table">
        <thead>
          <tr>
            <th>#</th>
            <th>SKU</th>
            <th class="d-none d-sm-table-cell">Name</th>
            <th class="d-none d-sm-table-cell">Fac. number</th>
            <th>Quantity</th>
            <th>Price</th>
            <th class="d-print-block d-none text-center">Location</th>
            <th class="d-print-none d-none d-sm-table-cell">Sell</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(article, i) of filteredList" v-bind:key="article.Sku">
            <td class="align-middle">{{i+1}}</td>
            <td class="align-middle" @click="whereIsIt(article.AdminComment ? article.AdminComment : 'NIJE U SISTEMU')" style="cursor: pointer;">
              {{article.Sku}}
            </td>
            <td class="d-none d-sm-table-cell align-middle">
              {{article.GenericName === 'Unknown' ? 'Nepoznat naziv' : article.GenericName}}
            </td>
            <td class="d-none d-sm-table-cell align-middle">{{article.num}}</td>
            <td class="text-center align-middle">{{article.StockQuantity}}</td>
            <td class="text-center align-middle">{{article.Price}}</td>
            <td class="d-print-block d-none text-center align-middle">{{article.AdminComment}}</td>
            <td class="d-print-none d-none d-sm-table-cell text-center align-middle">
              <button @click="addToCart(article)" class="btn btn-outline-light">
                <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-cart-plus" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM3.102 4l1.313 7h8.17l1.313-7H3.102zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm7 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>
                  <path fill-rule="evenodd" d="M8.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H9v1.5a.5.5 0 0 1-1 0V8H6.5a.5.5 0 0 1 0-1H8V5.5a.5.5 0 0 1 .5-.5z"/>
                </svg>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

import fixed from '../fixed';

export default {
  name: 'LagerList',
  data: () => ({
    loading: true,
    holdOn: false,
    list: [],
    total: 0,
    search: '',
    order: {},
    lokacija: '',
    to: null,
  }),
  mounted() {
    this.loadLager();
  },
  computed: {
    filteredList() {
      return this.list.filter((row) => row.Sku.match(this.search));
    },
    totalCart() {
      return Object.values(this.order).reduce((acc, val) => acc + (val.count * val.price), 0);
    },
  },
  methods: {
    async loadLager() {
      try {
        const { data } = await axios.get(`${fixed.API_URL}/admin/lager-list`, { withCredentials: true });
        this.list = data.list;
        this.total = (data.total - (data.total * 0.25)).toLocaleString();
        this.loading = false;
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.$toast.warning('you\'re not authorised for that action ✋🏻');
        } else {
          this.$toast.error('Error while fetching lager-list');
        }
        this.$router.push({ name: 'home' });
      }
    },
    whereIsIt(artikal) {
      if (this.to) clearTimeout(this.to);
      this.lokacija = artikal;
      this.to = setTimeout(() => {
        this.lokacija = '';
      }, 3000);
    },
    addToCart(artikal) {
      if (!this.order[artikal.Sku]) {
        this.$set(this.order, artikal.Sku, {
          sku: artikal.Sku,
          price: artikal.Price,
          stock: artikal.StockQuantity,
          count: 1,
          num: artikal.num,
        });
      } else {
        if (this.order[artikal.Sku].count >= this.order[artikal.Sku].stock) return;
        this.order[artikal.Sku].count += 1;
      }
    },
    reduceCount(sku) {
      if (this.order[sku].count === 1) {
        this.order[sku] = null;
        delete this.order[sku];
      } else {
        this.order[sku].count -= 1;
      }
    },
    async storeOrder() {
      const payload = Object.values(this.order).map((val) => val);
      this.holdOn = true;
      try {
        await axios.post(`${fixed.API_URL}/admin/create-order`, payload, { withCredentials: true });
        this.$bvModal.show('success');
        await this.loadLager();
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.$toast.warning('you\'re not authorised for that action ✋🏻');
        } else {
          alert(error); // eslint-disable-line
        }
      }
      this.holdOn = false;
      this.order = {};
    },
    async exportArticles() {
      const payload = Object.values(this.order).map((val) => val);
      this.holdOn = true;
      try {
        await axios.post(`${fixed.API_URL}/admin/export-order`, payload, { withCredentials: true });
        this.$bvModal.show('success');
        await this.loadLager();
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.$toast.warning('you\'re not authorised for that action ✋🏻');
        } else {
          alert(error); // eslint-disable-line
        }
      }
      this.holdOn = false;
      this.order = {};
    },
    otkazi() {
      this.order = {};
    },
    printaj() {
      window.print();
    },
  },
};
</script>

<style>
  .title {
    margin-top: 1rem;
  }
  .pretraga-container {
    margin: 1rem 0;
  }

  /* Floating cart */
  .korpa {
    background-color: #1d2129 !important;
    border: 1px solid var(--border-strong) !important;
    box-shadow: var(--shadow-lg);
  }
  .korpa .list-group-item {
    background-color: var(--surface-2);
    color: var(--text);
  }
  .korpa .list-group-item input {
    background-color: transparent;
    color: var(--text);
    border-radius: var(--radius-sm);
  }
  .korpa .list-group-item input:focus {
    background-color: var(--surface-3);
    outline: none;
  }
  .remove-icon {
    cursor: pointer;
  }

  .hold-on {
    background-color: rgba(17, 18, 22, .85);
    position: absolute;
    z-index: 100;
    min-width: 100%;
    min-height: 100%;
  }
</style>
